import * as React from "react";
import SuccessConfettiIcon from "../../../../assets/images/successVerifyID.svg";
import NewButton from "../../../../components/uiMerge/newButton";
import * as ROUTES from "../../../../constants/routes";

export const Finish: React.FC = () => {
  

  return (
    <div className="px-[1rem] text-white flex flex-col min-h-screen justify-between items-center">
      <div className="text-center w-full my-auto flex flex-col gap-[8px] justify-center items-center">
        <img src={SuccessConfettiIcon} alt="success" />
        <p className="text-2xl font-bold">
          ID Verified!
        </p>
        <p className="text-[16px] text-[#CECECF] w-[256px] font-normal">
          Your <span className="font-bold">ID</span> has been verified. You now have full access to everything Njoy perks.
        </p>
      </div>
      <div className="w-full py-5 flex flex-col">
        <a href={ROUTES.HOME}>
          <NewButton fullWidth>
            Go to Homepage
          </NewButton>
        </a>
      </div>
    </div>
  );
}